var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 747,
    height: 547,
    viewBox: "0 0 747 547",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    opacity: 0.0845424,
    d: "M674.32 166.249C683.698 153.731 701.453 151.18 713.979 160.552C726.379 169.83 729.005 187.315 719.957 199.81L719.679 200.187L645.379 299.374C635.916 312.007 618.34 315.21 605.04 306.802L604.639 306.544L557.865 275.948L510.705 344.593C501.937 357.356 484.564 360.694 471.702 352.171L471.313 351.909C458.543 343.146 455.204 325.783 463.732 312.928L463.994 312.54L525.793 222.586C534.999 209.185 553.141 205.492 566.841 214.144L567.255 214.41L614.898 245.575L674.32 166.249Z",
    fill: "#7367F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    opacity: 0.0845424,
    d: "M431.118 5.29424C433.496 1.83984 438.232 0.961284 441.696 3.33194C445.115 5.67139 446.018 10.3009 443.756 13.7421L443.664 13.8791L425.148 40.779C422.433 44.5698 417.181 45.4829 413.345 42.8606L413.208 42.7654L402.574 35.1946L391.048 53.4538C388.839 56.9536 384.234 58.0368 380.696 55.9185L380.557 55.8332C377.047 53.6305 375.96 49.0392 378.085 45.5109L378.17 45.3722L393.455 21.158C395.973 17.169 401.257 15.9705 405.258 18.4812L405.467 18.6168L405.673 18.7584L416.53 26.4883L431.118 5.29424Z",
    fill: "#7367F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "+",
    opacity: 0.070266,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M633.404 131.308C634.784 131.308 635.904 130.189 635.904 128.808V110.831H653.893C655.273 110.831 656.393 109.712 656.393 108.331V99.6761C656.393 98.2954 655.273 97.1761 653.893 97.1761H635.904V79.0664C635.904 77.6857 634.784 76.5664 633.404 76.5664H624.608C623.227 76.5664 622.108 77.6857 622.108 79.0664V97.1761H604.119C602.738 97.1761 601.619 98.2954 601.619 99.6761V108.331C601.619 109.712 602.738 110.831 604.119 110.831H622.108V128.808C622.108 130.189 623.227 131.308 624.608 131.308H633.404Z",
    fill: "#00CFE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    opacity: 0.0739397,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.602 22C143.193 22 184.206 62.9886 184.206 113.551C184.206 164.113 143.193 205.101 92.602 205.101C42.0105 205.101 0.998047 164.113 0.998047 113.551C0.998047 62.9886 42.0105 22 92.602 22ZM92.602 67.3034C67.0455 67.3034 46.3278 88.0089 46.3278 113.551C46.3278 139.092 67.0455 159.798 92.602 159.798C118.159 159.798 138.876 139.092 138.876 113.551C138.876 88.0089 118.159 67.3034 92.602 67.3034Z",
    fill: "#00CFE8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Meeting"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.5957 103C61.5957 94.1634 68.7591 87 77.5957 87H547.724C556.561 87 563.724 94.1634 563.724 103V307.224C563.724 316.061 556.561 323.224 547.724 323.224H77.5957C68.7592 323.224 61.5957 316.061 61.5957 307.224V103Z",
    fill: "#141A2B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1465 103C69.1465 94.1634 76.3099 87 85.1465 87H547.724C556.561 87 563.724 94.1634 563.724 103V307.224C563.724 316.061 556.561 323.224 547.724 323.224H85.1465C76.31 323.224 69.1465 316.061 69.1465 307.224V103Z",
    fill: "#181F33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.6973 104.559C76.6973 99.0362 81.1744 94.5591 86.6973 94.5591H546.173C551.696 94.5591 556.173 99.0362 556.173 104.559V305.665C556.173 311.188 551.696 315.665 546.173 315.665H86.6973C81.1744 315.665 76.6973 311.188 76.6973 305.665L76.6973 104.559Z",
    fill: "#283046"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M275.85 301.823C275.85 298.509 278.536 295.823 281.85 295.823H351.021C354.334 295.823 357.021 298.509 357.021 301.823V315.665H275.85V301.823Z",
    fill: "#D4EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5",
    d: "M283.4 301.823C283.4 298.509 286.087 295.823 289.4 295.823H358.572C361.885 295.823 364.572 298.509 364.572 301.823V323.225H283.4V301.823Z",
    fill: "#91D6FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ElementCard20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6",
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.8555 109.397C90.8555 106.421 93.2681 104.008 96.2442 104.008H221.268C224.244 104.008 226.657 106.421 226.657 109.397V150.047C226.657 153.023 224.244 155.436 221.268 155.436H96.2442C93.2681 155.436 90.8555 153.023 90.8555 150.047V109.397Z",
    fill: "#313A53"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_7",
    opacity: 0.454078,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.037 134.559C131.037 133.715 131.721 133.031 132.565 133.031H157.992C158.836 133.031 159.52 133.715 159.52 134.559V134.559C159.52 135.403 158.836 136.087 157.992 136.087H132.565C131.721 136.087 131.037 135.403 131.037 134.559V134.559Z",
    fill: "#C7C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.037 125.903C131.037 125.059 131.721 124.375 132.565 124.375H147.82C148.663 124.375 149.347 125.059 149.347 125.903V125.903C149.347 126.747 148.663 127.431 147.82 127.431H132.565C131.721 127.431 131.037 126.747 131.037 125.903V125.903Z",
    fill: "#8478FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.813 122.284C207.983 119.429 212.053 118.876 214.904 121.049C215.56 121.548 216.115 122.169 216.539 122.876C216.758 123.241 216.639 123.714 216.275 123.933C215.911 124.151 215.439 124.033 215.22 123.668C214.897 123.128 214.473 122.655 213.973 122.274C211.842 120.651 208.819 121.022 207.14 123.085L207.037 123.216L204.652 126.353C200.927 131.254 194.624 133.414 188.693 131.848L188.439 131.779L186.521 131.237C186.397 131.202 186.273 131.171 186.147 131.143C182.639 130.369 179.168 132.541 178.309 136.011L178.269 136.182L177.873 137.98C177.733 138.617 177.462 139.217 177.076 139.741C175.551 141.817 172.633 142.262 170.559 140.735C170.217 140.483 170.144 140.001 170.396 139.659C170.647 139.316 171.129 139.243 171.471 139.495C172.86 140.518 174.815 140.22 175.837 138.829C176.063 138.521 176.231 138.175 176.332 137.808L176.371 137.649L176.767 135.851C177.735 131.451 182.083 128.67 186.478 129.639L186.709 129.694L186.938 129.755L188.857 130.297C194.172 131.799 199.857 129.946 203.272 125.622L203.428 125.421L205.813 122.284Z",
    fill: "#8478FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.882 121.353C200.452 117.857 204.557 116.296 208.049 117.869C208.751 118.184 209.395 118.615 209.956 119.142C211.275 120.384 212.497 122.347 213.642 125.035C213.808 125.426 213.627 125.878 213.236 126.045C212.845 126.212 212.394 126.03 212.227 125.639C211.158 123.13 210.043 121.338 208.902 120.264C208.466 119.854 207.965 119.519 207.419 119.273C204.75 118.072 201.623 119.22 200.353 121.838L200.285 121.984L199.79 123.086C199.675 123.343 199.542 123.591 199.394 123.83C197.566 126.766 193.707 127.663 190.774 125.834C190.425 125.616 190.042 125.458 189.641 125.366C187.689 124.919 185.745 126.102 185.23 128.022L185.197 128.157L184.341 131.899C184.083 133.026 183.535 134.067 182.753 134.917C180.312 137.571 176.214 137.785 173.513 135.434L173.369 135.305L169.883 132.092C169.57 131.804 169.55 131.317 169.838 131.004C170.107 130.712 170.548 130.675 170.86 130.905L170.925 130.959L174.411 134.173C176.484 136.083 179.713 135.95 181.621 133.874C182.176 133.271 182.577 132.543 182.792 131.754L182.841 131.555L183.697 127.813C184.344 124.985 187.159 123.217 189.984 123.865C190.481 123.979 190.958 124.165 191.4 124.416L191.588 124.527C193.8 125.907 196.71 125.23 198.088 123.016C198.163 122.896 198.232 122.772 198.296 122.646L198.387 122.455L198.882 121.353Z",
    fill: "#C7C1FF"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_2",
    cx: 113.489,
    cy: 130.231,
    rx: 10.4267,
    ry: 10.4383,
    fill: "#8478FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ElementCard3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9",
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.8555 167.592C90.8555 164.83 93.094 162.592 95.8555 162.592H254.805C257.566 162.592 259.805 164.83 259.805 167.592V300.271C259.805 303.033 257.566 305.271 254.805 305.271H95.8555C93.094 305.271 90.8555 303.033 90.8555 300.271V167.592Z",
    fill: "#313A53"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 90,
    y: 162,
    width: 170,
    height: 144
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.8555 167.592C90.8555 164.83 93.094 162.592 95.8555 162.592H254.805C257.566 162.592 259.805 164.83 259.805 167.592V300.271C259.805 303.033 257.566 305.271 254.805 305.271H95.8555C93.094 305.271 90.8555 303.033 90.8555 300.271V167.592Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path 3",
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.508 272.2C113.508 272.2 133.593 266.426 142.449 254.639C151.305 242.853 154.291 231.428 169.522 231.428C184.754 231.428 186.706 248.926 203.172 248.926C219.638 248.926 220.538 226.612 226.011 217.752C231.483 208.892 240.928 208.892 240.928 208.892",
    stroke: "#8EEAF6",
    strokeWidth: 4.004,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path 3_2",
    opacity: 0.414737,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.508 270.982C113.508 270.982 133.593 265.232 142.449 253.497C151.305 241.761 154.291 230.386 169.522 230.386C184.754 230.386 186.706 247.808 203.172 247.808C219.638 247.808 220.538 225.59 226.011 216.769C231.483 207.947 240.928 207.947 240.928 207.947V282.348C240.928 284.049 239.549 285.428 237.848 285.428H116.588C114.887 285.428 113.508 284.049 113.508 282.348V270.982Z",
    fill: "#CEF9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    x: 104.07,
    y: 176.765,
    width: 52.8556,
    height: 5.66939,
    rx: 2.83469,
    fill: "#8EEAF6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.07 193.773C104.07 192.208 105.339 190.939 106.905 190.939H125.776C127.341 190.939 128.61 192.208 128.61 193.773V193.773C128.61 195.339 127.341 196.608 125.776 196.608H106.905C105.339 196.608 104.07 195.339 104.07 193.773V193.773Z",
    fill: "#8EEAF6",
    fillOpacity: 0.401934
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_3",
    cx: 227.241,
    cy: 180.073,
    rx: 3.30348,
    ry: 3.30714,
    fill: "#8EEAF6",
    fillOpacity: 0.451705
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_4",
    cx: 236.68,
    cy: 180.073,
    rx: 3.30348,
    ry: 3.30714,
    fill: "#8EEAF6",
    fillOpacity: 0.451705
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_5",
    cx: 246.118,
    cy: 180.073,
    rx: 3.30348,
    ry: 3.30714,
    fill: "#8EEAF6",
    fillOpacity: 0.451705
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ElementCard11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_13",
    filter: "url(#filter3_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M286.232 124.721C286.232 120.588 289.583 117.237 293.717 117.237H518.929C523.063 117.237 526.414 120.588 526.414 124.721V275.237C526.414 279.371 523.063 282.721 518.929 282.721H293.717C289.583 282.721 286.232 279.371 286.232 275.237V124.721Z",
    fill: "#313A53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M326.852 202.101V261.287H318.021V202.101H326.852Z",
    fill: "#E7E4FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M326.852 216.245V261.287H318.021V216.245H326.852Z",
    fill: "#C7C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M326.852 244.533V261.287H318.021V244.533H326.852Z",
    fill: "#8478FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 26_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.043 187.957V261.287H339.213V187.957H348.043Z",
    fill: "#E7E4FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.043 209.173V261.287H339.213V209.173H348.043Z",
    fill: "#C7C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.043 244.533V261.287H339.213V244.533H348.043Z",
    fill: "#8478FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 26_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M369.236 198.565V261.287H360.406V198.565H369.236Z",
    fill: "#E7E4FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M369.236 219.781V261.287H360.406V219.781H369.236Z",
    fill: "#C7C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M369.236 248.069V261.287H360.406V248.069H369.236Z",
    fill: "#8478FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 26_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M390.428 180.885V261.287H381.598V180.885H390.428Z",
    fill: "#E7E4FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M390.428 202.101V261.287H381.598V202.101H390.428Z",
    fill: "#C7C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M390.428 230.389V261.287H381.598V230.389H390.428Z",
    fill: "#8478FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 26_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M411.621 166.741V261.287H402.791V166.741H411.621Z",
    fill: "#E7E4FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M411.621 195.029V261.287H402.791V195.029H411.621Z",
    fill: "#C7C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M411.621 237.461V261.287H402.791V237.461H411.621Z",
    fill: "#8478FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 26_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M432.815 187.957V261.287H423.984V187.957H432.815Z",
    fill: "#E7E4FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M432.815 209.173V261.287H423.984V209.173H432.815Z",
    fill: "#C7C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M432.815 241.704V261.287H423.984V241.704H432.815Z",
    fill: "#8478FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 26_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M454.006 195.029V261.287H445.176V195.029H454.006Z",
    fill: "#E7E4FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M454.006 209.173V261.287H445.176V209.173H454.006Z",
    fill: "#C7C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M454.006 236.754V261.287H445.176V236.754H454.006Z",
    fill: "#8478FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 26_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M475.199 180.885V261.287H466.369V180.885H475.199Z",
    fill: "#E7E4FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M475.199 209.173V261.287H466.369V209.173H475.199Z",
    fill: "#C7C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M475.199 243.825V261.287H466.369V243.825H475.199Z",
    fill: "#8478FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 26_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M496.391 195.029V261.287H487.561V195.029H496.391Z",
    fill: "#E7E4FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M496.391 209.173V261.287H487.561V209.173H496.391Z",
    fill: "#C7C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M496.391 243.826V261.287H487.561V243.826H496.391Z",
    fill: "#8478FF"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_14",
    opacity: 0.57573,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M315.195 147.647C315.195 146.475 316.145 145.525 317.317 145.525H387.954C389.125 145.525 390.075 146.475 390.075 147.647V147.647C390.075 148.818 389.125 149.768 387.954 149.768H317.317C316.145 149.768 315.195 148.818 315.195 147.647V147.647Z",
    fill: "#8C81FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    x: 315.195,
    y: 133.502,
    width: 39.5593,
    height: 4.2432,
    rx: 2.1216,
    fill: "#8478FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Chair4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M559.039 451.882L570.482 542.29L564.483 542.21L553.04 452.728L559.039 451.882Z",
    fill: "#BFE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M481.617 466.093C476.401 466.093 472.172 461.864 472.172 456.648V456.648C472.172 451.431 476.401 447.203 481.617 447.203H519.379C525.101 447.203 529.883 442.849 530.419 437.153L536.457 372.96C536.992 367.263 541.774 362.91 547.496 362.91H571.196C577.654 362.91 582.746 368.408 582.251 374.848L576.027 455.854C575.583 461.632 570.766 466.093 564.972 466.093H481.617Z",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M472.174 456.567C472.226 456.568 472.278 456.568 472.33 456.568H555.46C561.253 456.568 566.07 452.108 566.515 446.332L572.735 365.614C572.802 364.734 572.766 363.872 572.636 363.038C572.084 362.954 571.519 362.91 570.942 362.91H547.353C541.633 362.91 536.852 367.262 536.314 372.957L530.281 436.916C529.744 442.611 524.963 446.963 519.242 446.963H481.593C476.39 446.963 472.172 451.181 472.172 456.384C472.172 456.445 472.172 456.506 472.174 456.567Z",
    fill: "#BFE7FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Wom1.4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Head"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M546.276 347.34C558.474 344.498 559.277 327.746 550.003 321.935C559.567 301.875 537.45 281.958 522.3 294.241C512.368 289.987 504.114 306.586 513.356 319.478C509.481 341.613 517.368 347.335 531.584 347.578L546.276 347.34Z",
    fill: "#422851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M546.123 343.339C546.123 343.339 540.189 341.946 539.983 332.217C539.778 322.489 539.922 319.169 539.922 319.169L526.852 318.933C526.852 318.933 526.709 329.774 526.707 333.696C526.702 344.229 519.367 343.339 519.367 343.339C519.367 343.339 520.891 351.88 532.735 352.546C541.982 353.067 546.123 343.339 546.123 343.339Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M542.97 314.311C548.801 314.085 547.85 322.626 541.793 322.614C541.793 322.614 538.275 334.746 526.061 334.746C516.141 334.746 515.496 320.606 515.406 317.785C515.309 314.777 515.297 304.897 515.297 304.897L543.197 304.884L542.97 314.311Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    d: "M528.416 326.596C528.416 326.596 525.507 329.06 522.137 326.752",
    stroke: "#F77B7B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    d: "M526.494 329.45C525.589 329.868 524.717 329.898 523.939 329.482",
    stroke: "#F49494",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 8",
    d: "M542.375 318.904C542.315 317.534 542.732 316.446 544.129 316.227",
    stroke: "#F77B7B",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M543.892 313.256C543.892 313.256 540.696 317.546 540.049 317.569C539.402 317.592 539.175 311.989 539.175 311.989C535.254 311.689 525.333 309.712 522.901 305.107C521.2 309.17 517.948 310.975 515.812 310.629L515.407 319.261L514.41 301.906H544.674L543.892 313.256Z",
    fill: "#422851"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LLeg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M486.404 514.891C486.404 514.891 491.635 525.462 487.347 528.793C483.052 532.125 471.708 538.368 471.708 538.368L501.762 536.478L495.081 513.424L486.404 514.891Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M498.854 524.951C497.371 525.125 498.955 530.121 495.744 530.501C492.539 530.88 490.981 526.147 487.345 527.647C483.708 529.148 470.444 536.906 469.922 540.078C469.393 543.249 474.335 544.182 481.112 543.466C487.889 542.75 489.138 540.337 494.226 541.309C499.307 542.28 503.113 540.732 502.946 537.017C502.778 533.303 500.337 524.778 498.854 524.951Z",
    fill: "#222D4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M485.685 528.417L486.345 529.407C486.669 529.893 486.51 530.551 486.001 530.835L477.035 535.841C476.744 536.003 476.392 536.01 476.095 535.86L474.703 535.153C476.889 533.569 478.676 532.379 480.652 531.21C482.168 530.313 483.847 529.388 485.685 528.417Z",
    fill: "white",
    fillOpacity: 0.540975
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M531.675 421.725C522.576 422.131 471.937 433.338 462.736 435.242C453.536 437.146 445.757 447.448 452.773 459.377C460.653 472.768 480.984 510.799 485.921 519.373C488.364 523.616 500.69 521.237 497.794 514.115C492.397 500.838 489.891 467.485 476.13 455.324C476.13 455.324 522.407 463.382 542.396 454.152C556.924 447.442 553.638 420.742 531.675 421.725Z",
    fill: "url(#paint3_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LArm"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M467.208 367.893C467.208 367.893 467.311 360.486 464.722 356.615C462.132 352.744 462.029 348.632 460.069 348.766C458.109 348.901 460.05 358.458 460.05 358.458C460.05 358.458 457.563 357.508 455.777 356.306C453.99 355.103 448.573 349.176 447.308 350.226C445.161 352.016 448.618 362.111 450.501 364.129C452.39 366.148 462.71 372.787 462.71 372.787L467.208 367.893Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M523.122 363.454C518.889 373.276 511.14 391.32 507.945 396.703C503.941 403.444 497.628 406.414 490.236 401.413C482.468 396.157 461.081 375.657 460.454 371.014C459.832 366.37 465.067 360.799 469.804 363.683C474.54 366.568 494.222 382.956 494.222 382.956C494.222 382.956 502.165 362.583 508.555 350.782C514.088 340.572 529.564 348.523 523.122 363.454Z",
    fill: "#6A5EE3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M494.141 382.966C494.141 382.966 492.007 390.206 491.509 389.787C491.01 389.368 491.89 381.074 491.89 381.074L494.141 382.966Z",
    fill: "black",
    fillOpacity: 0.302803
  })), /*#__PURE__*/React.createElement("g", {
    id: "Body"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M565.42 351.62C565.42 351.62 555.221 385.791 554.918 392.259C554.616 398.728 563.26 417.74 561.789 422.545C558.395 433.65 515.072 438.431 513.417 423.493C512.645 416.526 514.251 410.273 512.4 402.064C510.556 393.855 503.142 381.657 507.347 370.188C511.552 358.719 510.425 348.109 513.433 346.103C516.441 344.098 523.472 341.968 523.472 341.968C526.891 347.002 538.434 346.929 543.941 341.613C543.941 341.613 557.624 344.269 565.42 351.62Z",
    fill: "#7367F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M556.28 357.154C549.481 367.949 549.501 386.745 545.85 389.206C542.199 391.668 527.987 389.252 527.987 391.202C527.987 393.151 547.626 411.016 544.402 419.557C542.714 424.029 543.172 428.029 545.776 431.559L546.626 431.373C554.364 429.624 560.585 426.482 561.788 422.545C563.26 417.74 553.619 398.728 553.921 392.259C554.177 386.768 562.284 361.315 564.729 353.747C562.738 350.234 559.922 351.37 556.28 357.154Z",
    fill: "black",
    fillOpacity: 0.199355
  })), /*#__PURE__*/React.createElement("g", {
    id: "RArm"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M544.688 385.794C544.688 385.794 536.097 378.187 533.467 377.304C530.837 376.421 515.434 375.36 515.532 377.355C515.642 379.493 523.915 379.37 524.772 380.421C525.629 381.472 525.824 388.659 529.064 389.465C532.298 390.272 541.993 391.663 541.993 391.663L544.688 385.794Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M567.542 353.583C576.593 366.364 584.32 385.833 587.287 393.423C590.253 401.013 587.261 412.462 574.218 410.214C561.198 407.973 540.482 395.792 538.19 392.239C535.898 388.686 539.38 382.221 543.765 383.067C547.828 383.85 567.978 392.423 567.978 392.423C567.978 392.423 555.015 369.432 551.849 363.269C546.561 352.976 559.569 342.322 567.542 353.583Z",
    fill: "#6A5EE3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M567.774 392.266C567.774 392.266 574.564 395.641 573.736 394.225C572.908 392.81 565.183 387.837 565.183 387.837L567.774 392.266Z",
    fill: "black",
    fillOpacity: 0.302803
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Men3.2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LLeg_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.062 511.194C235.062 511.194 234.926 519.906 240.272 523C245.618 526.095 253.901 531.844 253.901 531.844L222.393 532.913L223.291 511.116L235.062 511.194Z",
    fill: "#F8CFCF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.292 520.794L220.779 534.926H228.098L228.599 533.105C228.599 533.105 231.355 532.992 232.947 533.779C234.63 534.61 234.856 535.014 234.856 535.014L258.07 535.063C258.07 535.063 259.215 530.495 252.139 527.191C245.063 523.887 239.91 519.197 238.932 518.717C237.946 518.233 235.957 517.96 234.556 519.096C233.156 520.232 232.048 523.219 228.874 523.312C224.789 523.433 222.442 518.404 221.292 520.794Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 38",
    d: "M241.131 520.25L238.725 522.577",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 38_2",
    d: "M244.639 522.014L242.232 524.342",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 38_3",
    d: "M248.149 523.779L245.742 526.107",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212 323C212 323 220.753 419.38 221.026 426.079C221.298 432.779 218.214 444.342 218.274 456.874C218.334 469.406 219.4 513.575 219.4 513.575L238.71 513.984C238.71 513.984 246.825 434.167 246.913 422.198C247 410.229 247.744 324.152 247.744 324.152L212 323Z",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    opacity: 0.283552,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.919 429.079L225.94 429.318C226.231 433.404 223.693 446.846 218.327 469.645L218.274 456.874V456.874C218.215 444.565 221.189 433.192 221.037 426.443L221.026 426.079C220.934 423.822 219.879 411.379 218.521 395.872L219.155 398.143C222.878 411.595 225.132 421.908 225.919 429.079Z",
    fill: "white",
    fillOpacity: 0.192499
  })), /*#__PURE__*/React.createElement("g", {
    id: "RLeg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.478 509.966L184.754 532.525L198.482 532.456L198.916 509.613L188.478 509.966Z",
    fill: "#F8CFCF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.001 519.724C185.657 520.015 184.683 521.182 184.638 522.556L184.527 525.91C182.585 528.064 181.668 534.287 181.571 534.977C181.565 535.02 181.561 535.061 181.566 535.105C181.851 538.154 201.82 538.116 203.695 535.249C203.78 535.118 203.786 534.963 203.761 534.809C203.551 533.538 202.435 527.385 200.29 525.707L200.277 522.384C200.272 521.031 199.362 519.849 198.055 519.498L195.992 518.944C193.985 516.017 191.25 516.121 188.907 519.31L187.001 519.724Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 39",
    d: "M189.686 521.748H195.243",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 39_2",
    d: "M189.686 524.393H195.243",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 39_3",
    d: "M190.568 527.037H194.358",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.401 324.265C195.401 324.265 189.268 390.331 189.351 402.982C189.434 415.635 191.239 421.191 188.671 430.267C186.102 439.343 183.912 511.786 183.912 511.786L202.903 513.864C202.903 513.864 215.036 436.346 216.355 425.599C217.674 414.851 233.98 323.353 233.98 323.353L195.401 324.265Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    opacity: 0.283552,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.53 369.105L199.372 373.298C195.98 385.674 192.849 398.761 193.669 417.455L193.709 418.309C193.91 422.358 191.334 445.861 185.98 488.817L185.471 491.836C184.946 494.915 184.478 497.542 184.068 499.717L184.185 495.913C184.867 474.915 186.704 437.216 188.67 430.267C191.238 421.191 189.434 415.635 189.35 402.983C189.292 394.126 192.28 359.097 194.078 338.877L195.401 324.265L203.417 324.076L203.437 326.326C203.578 347.099 202.609 361.358 200.53 369.105V369.105Z",
    fill: "white",
    fillOpacity: 0.192499
  })), /*#__PURE__*/React.createElement("g", {
    id: "LArm_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.834 242.566C288.834 242.566 287.249 233.828 287.819 232.058C288.306 230.529 292.908 228.324 292.908 228.324C292.908 228.324 300.912 215.818 302.664 217.091C304.089 218.123 298.496 227.343 298.496 227.343C298.496 227.343 303.596 232.636 303.525 235.002C303.454 237.368 295.2 244.774 295.2 244.774L288.834 242.566Z",
    fill: "#F8CFCF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.08 228.198C293.08 228.198 296.625 227.721 297.189 228.812C297.67 229.742 294.725 232.379 294.725 233.12C294.725 233.861 294.767 239.471 295.004 239.522C295.241 239.573 298.555 230.367 297.848 228.42C297.266 226.821 293.08 228.198 293.08 228.198Z",
    fill: "#F28585"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.546 253.684C237.261 245.662 223.318 260.124 238.865 273.569C244.797 278.699 263.428 291.493 267.996 294.307C275.267 298.785 281.242 294.744 283.697 287.697C285.78 281.723 298.239 249.743 296.653 245.046C295.62 241.982 290.071 239.001 287.286 241.412C283.216 244.935 270.766 275.839 270.766 275.839C270.766 275.839 257.104 262.805 246.546 253.684Z",
    fill: "#877BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.766 275.839C270.766 275.839 274.843 280.786 275.138 280.03C275.432 279.275 271.904 272.918 271.904 272.918L270.766 275.839Z",
    fill: "black",
    fillOpacity: 0.159856
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 41",
    d: "M286.203 243.393C289.443 241.893 292.982 243.748 294.932 246.724",
    stroke: "#5386BF",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Head_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.742 244.431C206.742 244.431 212.08 243.203 212.266 234.628C212.451 226.053 212.321 223.125 212.321 223.125L224.977 222.917C224.977 222.917 225.104 232.474 225.107 235.931C225.111 243.456 230.812 245.49 230.812 245.49C230.812 245.49 230.339 253.718 219.684 254.306C211.365 254.765 206.742 244.431 206.742 244.431Z",
    fill: "#F8C5C5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Head1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.249 213.882L235.967 221.986C238.358 219.23 239.974 215.814 240.452 211.433L236.249 213.882Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.157 218.791C205.912 218.592 206.768 226.12 212.217 226.11C212.217 226.11 218.073 237.654 227.267 237.684C231.696 237.698 233.141 233.831 234.469 231.116C235.797 228.401 236.771 224.34 236.852 221.854C236.939 219.202 236.95 210.493 236.95 210.493L210.953 210.481L211.157 218.791Z",
    fill: "#F8CFCF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.95 214.489H218.667C218.475 217.728 217.377 220.417 214.591 222.401C214.67 227.146 216.289 230.6 219.097 233.023C221.541 226.155 236.494 228.034 235.406 232.515C233.121 241.929 211.706 242.142 213.005 220.476C212.151 219.334 209.096 219.12 208.09 220.262C206.372 215.529 207.105 208.832 212.073 207.864C208.173 197.777 261.195 195.643 236.95 214.489Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    d: "M225.234 232.099C225.234 232.099 227.617 233.815 230.752 231.939",
    stroke: "#CC6969",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 8_2",
    d: "M211.975 223.089C212.029 221.881 211.653 220.922 210.396 220.729",
    stroke: "#DE6767",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Body_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.089 243L224.192 252.796L231.002 244.887C231.002 244.887 245.348 249.327 248.01 254.518C251.85 262.008 246.79 322.022 248.996 325.643C253.697 333.36 247.447 338.658 226.757 340.604C206.067 342.55 187.712 340.957 191.042 330.658C194.374 320.359 181.519 253.147 192.852 249.445C196.393 248.288 209.089 243 209.089 243Z",
    fill: "#7367F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.897 261.529C199.812 263.144 199.34 268.737 197.483 278.309C195.9 286.464 197.71 294.899 202.487 301.705L202.756 302.081C204.371 304.311 205.861 307.247 207.224 310.889C210.568 319.82 202.856 327.266 208.766 341.239L208.051 341.205C196.455 340.606 188.79 337.623 191.042 330.658C193.774 322.214 185.624 275.51 188.847 256.921C194.426 258.015 197.776 259.551 198.897 261.529Z",
    fill: "black",
    fillOpacity: 0.159856
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.089 243L222.598 251.795C220.618 254.093 219.556 256.766 219.155 259.709C213.963 255.656 208.567 249.992 206.895 243.902L209.089 243Z",
    fill: "#5E54C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.26 251.566C227.544 253.108 229.366 255.839 230.85 258.944C232.628 255.376 233.309 250.664 233.309 245.639L231.078 244.759L225.26 251.566Z",
    fill: "#5E54C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.598 251.794L222.774 251.893C223.584 252.344 224.594 252.211 225.259 251.566V251.566C230.352 270.207 233.934 290.724 235.017 311.576L229.702 320.39L223.485 312.141C224.295 290.47 224.289 269.339 222.598 251.794Z",
    fill: "#CBC6FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RArm_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Example Book Back"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_16",
    d: "M236.081 298.99C236.228 297.598 237.503 296.607 238.888 296.81L251.194 298.609C252.502 298.8 253.427 299.99 253.288 301.304L251.08 322.318C250.933 323.71 249.658 324.701 248.273 324.499L235.967 322.7C234.659 322.509 233.735 321.319 233.873 320.004L236.081 298.99Z",
    fill: "#6182EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.549 298.567C237.7 297.128 239.053 296.128 240.473 296.407L253.34 298.93L262.145 298.783C263.624 298.758 264.792 300.033 264.637 301.504L262.432 322.486C262.302 323.724 261.268 324.671 260.023 324.692L250.616 324.849L237.318 322.241C236.066 321.995 235.208 320.834 235.342 319.565L237.549 298.567Z",
    fill: "#96EFFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_18",
    d: "M239.872 303.487C239.97 302.56 240.835 301.913 241.751 302.08L247.657 303.161C248.48 303.312 249.048 304.07 248.96 304.902L248.708 307.296C248.611 308.223 247.746 308.871 246.829 308.703L240.924 307.622C240.101 307.472 239.533 306.713 239.621 305.881L239.872 303.487Z",
    fill: "#74CFDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_19",
    d: "M252.356 299.631C252.402 299.192 252.796 298.873 253.235 298.919L253.752 298.974C254.191 299.02 254.51 299.413 254.464 299.853L251.916 324.097C251.87 324.536 251.476 324.855 251.037 324.809L250.52 324.754C250.08 324.708 249.762 324.315 249.808 323.875L252.356 299.631Z",
    fill: "#EAEFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_20",
    d: "M253.059 299.705C253.105 299.266 253.499 298.947 253.938 298.993L254.455 299.048C254.895 299.094 255.213 299.487 255.167 299.927L252.619 324.171C252.573 324.61 252.179 324.929 251.74 324.883L251.223 324.828C250.783 324.782 250.465 324.389 250.511 323.949L253.059 299.705Z",
    fill: "#7AD2DD"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.89 308.414C222.89 308.414 227.476 307.498 229.353 306.033C231.23 304.569 236.915 303.534 236.915 303.534L235.096 307.34C235.096 307.34 249.028 306.04 249.358 307.406C249.689 308.771 245.659 310.256 245.659 310.256C245.659 310.256 243.672 313.944 241.748 316.082C239.928 318.105 230.884 317.864 227.714 316.602C224.975 315.511 221.996 316.056 221.996 316.056L222.89 308.414Z",
    fill: "#F8CFCF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.002 255.239C190.984 244.542 208.042 251.749 203.743 263.209C199.579 274.31 189.49 300.23 189.49 300.23C189.49 300.23 221.462 304.263 223.954 306.144C227.28 308.653 225.224 315.813 222.398 317.088C220.007 318.166 202.245 318.796 184.866 317.435C176.269 316.762 169.911 313.092 169.024 303.559C168.402 296.883 181.202 265.544 186.002 255.239Z",
    fill: "#877BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.502 300.224C189.502 300.224 186.845 305.243 187.604 305.345C188.364 305.448 192.225 300.591 192.225 300.591L189.502 300.224Z",
    fill: "black",
    fillOpacity: 0.159856
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 40",
    d: "M221.703 305.599C222.689 308.727 221.996 312.395 220.628 314.988",
    stroke: "#5386BF",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vase2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.3628 445.346V445.346C94.6288 441.634 104.336 445.361 107.996 453.65L110.858 460.135V460.135C102.592 463.847 92.8847 460.12 89.2255 451.831L86.3628 445.346Z",
    fill: "#02D3AF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.1752 449.302C106.425 455.172 111.774 461.714 114.239 468.926C116.716 476.173 117.731 488.321 117.27 505.347C117.263 505.61 117.469 505.83 117.73 505.837C117.992 505.844 118.21 505.637 118.217 505.373C118.681 488.241 117.658 475.996 115.134 468.614C112.599 461.197 107.122 454.5 98.7211 448.521C98.5074 448.369 98.212 448.421 98.0613 448.636C97.9105 448.852 97.9615 449.15 98.1752 449.302Z",
    fill: "#02B596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.488 441.32V441.32C148.354 437.494 138.659 441.022 134.886 449.182L131.673 456.133V456.133C139.807 459.959 149.502 456.431 153.275 448.271L156.488 441.32Z",
    fill: "#02D3AF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 88"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_23",
    d: "M91.4961 425.385V425.385C99.34 423.718 107.05 428.725 108.718 436.569L110.067 442.919V442.919C102.223 444.586 94.5131 439.579 92.8458 431.735L91.4961 425.385Z",
    fill: "#02D3AF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.2643 430.452C103.31 434.672 107.399 439.223 109.544 444.099L109.676 444.406L109.809 444.729C112.007 450.185 115.645 464.475 120.705 487.545C120.761 487.802 121.014 487.966 121.27 487.91C121.525 487.854 121.686 487.599 121.63 487.342L121.003 484.496L120.271 481.202C115.7 460.761 112.418 448.281 110.41 443.715C108.187 438.662 103.981 433.981 97.8019 429.667C97.5865 429.517 97.2916 429.571 97.1431 429.787C96.9947 430.004 97.0489 430.301 97.2643 430.452Z",
    fill: "#02B596"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.623 420.56V420.56C135.978 420.408 128.847 427.294 128.698 435.94L128.564 443.653V443.653C137.209 443.805 144.34 436.919 144.49 428.273L144.623 420.56Z",
    fill: "#02D3AF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.951 423.662C133.39 431.822 129.326 439.699 126.763 447.293C124.203 454.874 121.65 466.581 119.1 482.424C119.058 482.684 119.233 482.93 119.491 482.972C119.75 483.014 119.993 482.837 120.035 482.577L120.348 480.651L120.563 479.353C122.93 465.186 125.296 454.6 127.659 447.601C130.193 440.095 134.217 432.295 139.731 424.203C139.879 423.985 139.825 423.688 139.609 423.539C139.394 423.389 139.099 423.444 138.951 423.662Z",
    fill: "#02B596"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 87"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.905 418.316C126.905 418.316 122.395 431.164 120.401 450.089C118.408 469.013 119.571 487.938 119.571 487.938L121.772 488.138C121.772 488.138 120.59 466.05 122.009 450.172C123.429 434.294 128.005 418.416 128.005 418.416L126.905 418.316Z",
    fill: "#02B596"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_6",
    cx: 129.201,
    cy: 411.952,
    rx: 7.26372,
    ry: 11.1372,
    transform: "rotate(14 129.201 411.952)",
    fill: "#C2FFF4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_7",
    cx: 129.347,
    cy: 412.624,
    rx: 5.05298,
    ry: 7.26093,
    transform: "rotate(14 129.347 412.624)",
    fill: "#02D3AF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.726 419.005L132.783 406.341C133.025 405.588 132.615 404.781 131.869 404.538C131.122 404.294 130.321 404.707 130.08 405.46L126.022 418.124C125.781 418.877 126.191 419.685 126.937 419.928C127.684 420.171 128.484 419.758 128.726 419.005Z",
    fill: "url(#paint7_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 87_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.95 405.586C104.95 405.586 110.778 417.892 114.739 436.505C118.7 455.117 119.521 474.06 119.521 474.06L117.354 474.489C117.354 474.489 116.22 452.399 113.149 436.756C110.077 421.113 103.867 405.801 103.867 405.801L104.95 405.586Z",
    fill: "#02B596"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_8",
    rx: 7.26372,
    ry: 11.1372,
    transform: "matrix(-0.939693 0.34202 0.34202 0.939693 102.001 399.496)",
    fill: "#C2FFF4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_9",
    rx: 5.05298,
    ry: 7.26093,
    transform: "matrix(-0.939693 0.34202 0.34202 0.939693 101.927 400.181)",
    fill: "#02D3AF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.214 406.462L97.8542 394.291C97.5356 393.568 97.8585 392.722 98.5755 392.402C99.2924 392.082 100.132 392.409 100.451 393.133L105.81 405.303C106.128 406.027 105.806 406.873 105.089 407.193C104.372 407.513 103.532 407.185 103.214 406.462Z",
    fill: "url(#paint8_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.02 443.348C140.792 447.742 132.964 452.819 128.537 458.599C124.111 464.378 121.186 473.341 119.744 485.49C119.713 485.752 119.898 485.99 120.157 486.021C120.417 486.053 120.653 485.866 120.684 485.604C122.108 473.611 124.982 464.803 129.287 459.183C133.591 453.563 141.282 448.575 152.362 444.239C152.606 444.143 152.727 443.867 152.632 443.621C152.538 443.375 152.264 443.253 152.02 443.348Z",
    fill: "#02B596"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 151",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.93 478.595C116.599 459.598 95.5469 465.157 95.5469 465.157C95.5469 465.157 111.308 470.308 119.346 478.595H121.93Z",
    fill: "#02B596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 151_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.875 475.677C127.206 456.679 144.975 459.457 144.975 459.457C144.975 459.457 134.183 468.328 124.458 475.677H121.875Z",
    fill: "#02B596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 151_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.835 479.453C117.069 462.599 128.186 448.092 128.186 448.092C128.186 448.092 127.623 468.052 123.759 478.222L121.835 479.453Z",
    fill: "#02B596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 114",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.172 475.677C115.065 469.587 112.969 461.082 111.398 452.837C119.161 455.959 121.655 468.397 119.161 475.677H117.172Z",
    fill: "#02D3AF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 89"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.024 471.762C101.921 470.584 102.849 469.571 104.032 469.571H134.684C135.866 469.571 136.795 470.584 136.692 471.762L130.785 539.355C130.694 540.396 129.822 541.195 128.777 541.195H109.939C108.893 541.195 108.021 540.396 107.93 539.355L102.024 471.762Z",
    fill: "#7569EC"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 102,
    y: 469,
    width: 35,
    height: 73
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_26",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.024 471.762C101.921 470.584 102.849 469.571 104.032 469.571H134.684C135.866 469.571 136.795 470.584 136.692 471.762L130.785 539.355C130.694 540.396 129.822 541.195 128.777 541.195H109.939C108.893 541.195 108.021 540.396 107.93 539.355L102.024 471.762Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_27",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.4102 465.099H110.354C102.333 495.552 126.48 516.488 110.354 546.941H97.4102V465.099Z",
    fill: "#8175FF"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Chair4_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M679.746 451.882L668.303 542.29L674.302 542.21L685.745 452.728L679.746 451.882Z",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M646.447 451.882L635.004 542.29L641.003 542.21L652.446 452.728L646.447 451.882Z",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M719.493 451.882L730.936 542.29L724.936 542.21L713.493 452.728L719.493 451.882Z",
    fill: "#BFE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M642.07 466.093C636.854 466.093 632.625 461.864 632.625 456.648V456.648C632.625 451.431 636.854 447.203 642.07 447.203H679.833C685.554 447.203 690.336 442.849 690.872 437.153L696.91 372.96C697.445 367.263 702.227 362.91 707.949 362.91H731.649C738.108 362.91 743.199 368.408 742.705 374.848L736.48 455.854C736.036 461.632 731.219 466.093 725.425 466.093H642.07Z",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M632.627 456.567C632.679 456.568 632.731 456.568 632.783 456.568H715.913C721.706 456.568 726.523 452.108 726.968 446.332L733.188 365.614C733.256 364.734 733.219 363.872 733.089 363.038C732.537 362.954 731.972 362.91 731.395 362.91H707.807C702.086 362.91 697.305 367.262 696.768 372.957L690.735 436.916C690.197 442.611 685.416 446.963 679.696 446.963H642.046C636.843 446.963 632.625 451.181 632.625 456.384C632.625 456.445 632.626 456.506 632.627 456.567Z",
    fill: "#BFE7FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Wom2.4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LLeg_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M644.11 513.415C644.11 513.415 649.356 524.01 645.055 527.349C640.748 530.688 629.372 536.946 629.372 536.946L659.512 535.052L652.812 511.944L644.11 513.415Z",
    fill: "url(#paint9_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M656.525 523.003C655.576 523.455 657.136 527.712 653.799 527.413C650.463 527.115 648.368 522.714 645.908 523C643.447 523.285 641.885 527.717 637.2 530.803C632.517 533.89 625.572 537.572 626.037 540.675C626.502 543.779 637.431 544.61 642.968 543.582C648.505 542.556 651.089 540.33 654.681 540.507C658.273 540.685 660.531 540.245 661.657 537.939C662.782 535.632 657.619 522.48 656.525 523.003Z",
    fill: "#EEDFE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M656.258 537.167L655.951 537.149C651.499 536.774 648.445 539.574 644.208 540.363C639.97 541.153 628.795 541.426 627.01 538.775C626.925 538.65 626.847 538.521 626.774 538.391C626.174 539.128 625.892 539.917 626.037 540.836C626.502 543.789 637.432 544.58 642.969 543.603C648.506 542.626 651.091 540.507 654.683 540.676L655.322 540.7C658.545 540.788 660.601 540.294 661.66 538.232C661.917 537.729 661.859 536.649 661.601 535.283C660.098 536.311 658.202 537.226 656.258 537.167V537.167Z",
    fill: "#EC7AA5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M689.511 420.032C680.387 420.439 629.601 431.672 620.375 433.58C611.148 435.488 603.347 445.814 610.383 457.772C618.285 471.194 638.675 509.314 643.626 517.907C646.076 522.16 658.437 519.775 655.534 512.636C650.121 499.329 647.607 465.898 633.807 453.709C633.807 453.709 680.217 461.786 700.264 452.534C714.833 445.808 711.537 419.047 689.511 420.032Z",
    fill: "#413C75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LArm_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M625.859 363.074C625.859 363.074 625.963 357.65 623.365 353.77C620.768 349.89 620.665 345.768 618.7 345.903C616.734 346.038 618.68 355.618 618.68 355.618C618.68 355.618 616.187 354.665 614.395 353.46C612.604 352.255 607.171 346.314 605.901 347.367C603.749 349.161 607.216 359.279 609.104 361.302C610.999 363.326 620.348 368.98 620.348 368.98L647.883 396.719L652 381.994L625.859 363.074Z",
    fill: "url(#paint10_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M680.934 360.625C676.689 370.47 668.917 388.556 665.713 393.951C661.698 400.708 655.366 403.686 647.953 398.672C646.402 397.623 641.948 393.954 641.948 393.954C642.607 387.532 645.006 382.164 649.142 377.849L651.951 380.172C651.951 380.172 659.917 359.752 666.325 347.924C671.874 337.69 687.395 345.659 680.934 360.625Z",
    fill: "#EA5455"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M651.869 380.183C651.869 380.183 649.73 387.44 649.23 387.019C648.729 386.599 649.612 378.286 649.612 378.286L651.869 380.183Z",
    fill: "black",
    fillOpacity: 0.159856
  })), /*#__PURE__*/React.createElement("g", {
    id: "Head_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M699.278 322.411V331.123L705.675 325.972C705.675 325.972 707.642 317.626 709.241 311.427C710.244 307.539 712.687 294.384 702.851 295C694.793 280.796 671.327 289.587 671.14 306.94C670.916 327.811 671.099 335.937 671.099 335.937C684.369 336.698 691.837 334.78 699.278 322.411Z",
    fill: "#422851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M705.812 338.997C705.812 338.997 699.862 337.6 699.655 327.85C699.449 318.099 699.594 314.77 699.594 314.77L686.486 314.534C686.486 314.534 686.343 325.401 686.341 329.332C686.335 338.889 679.307 339.672 679.307 339.672C679.307 339.672 680.508 347.558 692.386 348.226C701.659 348.748 705.812 338.997 705.812 338.997Z",
    fill: "url(#paint11_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M702.65 309.901C708.498 309.675 707.544 318.235 701.47 318.224C701.47 318.224 697.942 330.384 685.692 330.384C675.744 330.384 675.097 316.211 675.007 313.383C674.91 310.369 674.898 300.465 674.898 300.465L702.878 300.452L702.65 309.901Z",
    fill: "url(#paint12_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M703.103 309.845C700.68 310.245 700.974 311.849 700.315 311.709C696.969 310.997 683.425 311.936 681.681 304.488C679.511 309.141 678.98 310.285 674.202 311.534V297.899L704.424 295C704.424 295 703.955 309.704 703.103 309.845Z",
    fill: "#422851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    d: "M688.055 322.215C688.055 322.215 685.137 324.685 681.758 322.372",
    stroke: "#F77B7B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    d: "M686.129 325.075C685.221 325.494 684.347 325.525 683.567 325.107",
    stroke: "#F49494",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 8_3",
    d: "M702.053 314.505C701.993 313.132 702.412 312.041 703.812 311.822",
    stroke: "#F77B7B",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Body_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M704.484 338C697.016 342.574 688.382 344.251 680.345 339.284C667.23 365.145 663.961 396.002 667.116 430.106C686.241 437.678 702.315 436.189 716 427.534L704.484 338Z",
    fill: "#FFE4F4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "RLeg_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M611.415 513.84C611.415 513.84 611.573 526.311 601.297 530.973C591.028 535.635 583.711 535.355 584.643 538.959C585.574 542.563 612.304 542.418 614.8 539.599C616.928 537.201 621.554 514.872 622.828 516.579L611.415 513.84Z",
    fill: "url(#paint13_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M618.879 531.452C617.304 530.319 615.98 536.853 611.703 535.036C607.425 533.219 610.798 527.213 608.106 526.105C605.414 524.998 600.216 530.953 593.312 532.401C586.408 533.847 580.803 535.114 579.21 537.801C577.838 540.111 579.21 540.849 579.21 540.849C579.21 540.849 585.856 544.168 589.986 544.899C595.986 545.96 613.325 546.667 615.225 544.732C616.392 543.545 619.667 532.019 618.879 531.452Z",
    fill: "#EEDFE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M578.835 538.073C577.533 540.196 579.587 541.3 579.833 541.422L580.824 541.844C582.704 542.626 586.946 544.302 590.081 544.901C595.829 546 613.628 546.651 615.543 544.762C615.879 544.43 616.295 543.217 616.697 541.641L615.476 541.774C609.598 542.397 596.477 543.523 590.002 541.998C584.254 540.644 581.108 538.417 579.673 537.116C579.324 537.416 579.042 537.734 578.835 538.073Z",
    fill: "#EC7AA5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M718.102 416.177C718.102 416.177 731.368 444.192 712.725 453.812C694.696 463.115 640.724 452.112 640.724 452.112C640.724 452.112 641.689 459.877 640.724 466.802C638.206 484.889 626.226 515.023 623.692 518.809C620.187 524.046 609.51 520.097 609.309 515.737C609.107 511.377 617.357 455.693 618.612 445.075C619.86 434.456 623.8 432.913 635.309 430.01C637.953 429.343 669.22 421.573 672.084 421.8C696.695 423.746 718.102 416.177 718.102 416.177Z",
    fill: "#524D87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M703.56 450.921C685.711 452.921 638.456 448.798 636.558 450.671C634.746 452.46 635.049 483.575 630.984 501.585L631.602 499.884C635.425 489.267 639.394 476.354 640.724 466.802C641.689 459.877 640.724 452.112 640.724 452.112L642.901 452.533C653.16 454.46 696.86 461.999 712.725 453.812C721.322 449.376 724.83 442.006 723.249 431.703C720.527 443.349 713.964 449.755 703.56 450.921Z",
    fill: "white",
    fillOpacity: 0.056108
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M704.157 338.021C691.788 378.538 684.371 435.979 722.999 425.986C702.48 388.206 730.375 371.202 724.052 351.676C721.89 345 704.318 337.497 704.157 338.021Z",
    fill: "#EA5455"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M718.107 354.845C704.128 356.955 715.652 381.362 711.037 385.039C706.423 388.716 698.391 389.113 697.525 391.359C695.785 395.874 704.199 407.271 722.767 425.551L723 425.986C705.125 393.076 723.988 375.931 724.969 359.151C722.898 355.903 720.61 354.468 718.107 354.845Z",
    fill: "black",
    fillOpacity: 0.159856
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M681 339C676.28 350.838 674.011 360.127 671.894 377.503C670.129 391.975 671.013 421.84 671.013 421.84L665.18 422.987C665.18 422.987 661.01 376.848 662.404 370.907C664.744 360.938 666.329 355.113 669.418 346C671.12 340.998 681 339 681 339Z",
    fill: "#EA5455"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RArm_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M701.56 384.017C701.56 384.017 693.944 376.392 691.307 375.507C688.669 374.622 674.222 373.559 674.32 375.559C674.431 377.701 683.727 377.578 684.587 378.632C685.446 379.685 686.642 387.888 689.891 388.697C693.134 389.506 699.857 391.9 699.857 391.9L729.781 407.361L726.593 391.901L701.56 384.017Z",
    fill: "url(#paint14_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M724.48 351.731C733.557 364.542 741.307 384.056 744.282 391.664C747.256 399.272 744.256 410.747 731.175 408.494C729.618 408.226 727.084 407.24 727.084 407.24C722.275 400.647 721.431 394.987 723.226 389.947C723.226 389.947 724.918 390.661 724.918 390.661C724.918 390.661 711.917 367.617 708.742 361.439C703.44 351.122 716.485 340.444 724.48 351.731Z",
    fill: "#EA5455"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M724.919 390.661C724.919 390.661 731.523 393.886 730.692 392.468C729.862 391.049 722.404 386.182 722.404 386.182L724.919 390.661Z",
    fill: "black",
    fillOpacity: 0.159856
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Example Ipad1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_28",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M586.967 348.045C586.638 346.724 587.441 345.387 588.762 345.058L612.231 339.206C613.552 338.877 614.889 339.68 615.218 341.001L623.74 375.181C624.069 376.501 623.266 377.839 621.946 378.168L598.476 384.019C597.156 384.349 595.818 383.545 595.489 382.225L586.967 348.045Z",
    fill: "url(#paint15_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_29",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M587.883 348.595C587.554 347.275 588.358 345.938 589.678 345.608L613.147 339.757C614.468 339.428 615.805 340.231 616.134 341.552L624.656 375.732C624.985 377.052 624.182 378.389 622.862 378.719L599.392 384.57C598.072 384.899 596.734 384.096 596.405 382.775L587.883 348.595Z",
    fill: "#518DF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_30",
    d: "M588.884 348.896C588.588 347.708 589.311 346.504 590.499 346.208L612.571 340.705C613.76 340.408 614.963 341.132 615.26 342.32L622.965 373.223C623.261 374.411 622.538 375.615 621.349 375.911L599.277 381.414C598.089 381.71 596.885 380.987 596.589 379.799L588.884 348.896Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 26_10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_31",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M384.205 397.871H395.622V542.751H384.205L384.205 397.871Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_32",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.375 402.634L362.564 402.634V429.542H287.403V542.751H272.375V402.634Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_33",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M271.791 402.634H279.791V542.751H271.791V402.634Z",
    fill: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 25_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_34",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M664.43 402.634H680.43V542.751H664.43V402.634Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_35",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M664.43 397.871H674.43V542.751H664.43L664.43 397.871Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_36",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M532.006 402.634L671.006 402.634V429.19H550.713V542.751H532.006V402.634Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_37",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.59 397.871L532.479 397.871V438.101H283.59V397.871Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_38",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M526.771 402.634H538.188V438.101H526.771V402.634Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_39",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M532.041 402.634H541.041V542.751H532.041V402.634Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_40",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M533.477 405.015C533.477 401.07 536.675 397.871 540.62 397.871L685.746 397.871C689.691 397.871 692.889 401.07 692.889 405.015V405.015C692.889 408.96 689.691 412.158 685.746 412.158H540.62C536.675 412.158 533.477 408.96 533.477 405.015V405.015Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_41",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.736 400.729H529.626V415.016H280.736V400.729Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_42",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.805 405.015C259.805 401.07 263.003 397.871 266.948 397.871H543.412C547.358 397.871 550.556 401.07 550.556 405.015V405.015C550.556 408.96 547.358 412.158 543.412 412.158H266.948C263.003 412.158 259.805 408.96 259.805 405.015V405.015Z",
    fill: "#DBDBDB"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Men2.8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RLeg_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.388 507.181L296.49 532.824L313.057 533.425C313.057 533.425 311.186 524.653 313.857 516.43C316 509.829 317.748 506.535 317.748 506.535L304.388 507.181Z",
    fill: "#92691F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.622 526.378C312.622 526.378 318.945 532.238 325.026 534.409C331.107 536.58 333.435 536.604 333.868 537.421L333.947 537.577C335.198 540.159 334.439 543.589 320.578 543.779C317.209 543.825 313.706 541.868 304.408 539.797L303.736 543.417C298.532 543.348 295.496 542.528 294.627 540.956C293.317 538.605 295.543 527.011 297.079 526.791C298.614 526.571 298.918 531.287 303.041 531.39C307.17 531.493 312.622 526.378 312.622 526.378Z",
    fill: "#391B0B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M324.881 534.356C324.693 534.519 324.466 534.691 324.2 534.854C323.276 535.421 321.883 535.872 320.011 535.445C319.059 535.227 317.999 534.619 316.957 533.852C315.91 533.082 314.861 532.137 313.928 531.221C312.995 530.305 312.175 529.416 311.59 528.755C311.296 528.425 311.062 528.152 310.9 527.961C310.874 527.931 310.85 527.903 310.829 527.877C310.966 527.771 311.098 527.668 311.223 527.568C311.241 527.59 311.26 527.613 311.281 527.638C311.441 527.826 311.673 528.096 311.964 528.424C312.544 529.078 313.356 529.959 314.278 530.865C315.202 531.771 316.233 532.699 317.253 533.449C318.279 534.204 319.273 534.763 320.122 534.957C321.853 535.352 323.112 534.935 323.939 534.428C324.087 534.337 324.222 534.243 324.343 534.15C324.522 534.222 324.701 534.291 324.881 534.356Z",
    fill: "#81411E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.629 426.913C266.629 426.913 332.422 432.174 341.487 432.455C350.552 432.735 357.478 445.674 350.458 457.617C342.574 471.024 321.153 509.621 316.965 518.545C313.423 526.09 297.325 522.998 300.222 511.473C303.681 497.679 310.126 466.733 323.895 454.558C323.895 454.558 290.408 466.699 271.546 454.924C260.785 448.207 266.629 426.913 266.629 426.913Z",
    fill: "#7A3636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M350.46 457.617L349.434 459.376C345.444 466.272 339.001 477.923 332.85 489.27L333.173 488.231C337.931 473.092 345.322 455.258 348.482 449.817C349.59 447.91 351.098 445.966 353.006 443.985C353.816 448.14 353.201 452.954 350.46 457.617Z",
    fill: "white",
    fillOpacity: 0.192499
  })), /*#__PURE__*/React.createElement("g", {
    id: "LLeg_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375.987 507.48C375.987 507.48 380.385 527.038 386.11 529.131C388.314 529.937 369.218 532.238 369.218 532.238L364.424 513.474L375.987 507.48Z",
    fill: "#92691F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.46 525.631L366.141 542.142L372.723 542.192L372.79 538.48C372.79 538.48 377.92 541.556 381.394 542.638C386.066 544.097 404.525 543.333 406.61 541.11C408.696 538.877 408.741 535.324 404.459 534.887C400.178 534.451 393.098 533.151 390.05 530.818C386.363 528.007 384.96 523.547 383.889 523.543C382.25 523.537 382.123 528.784 373.804 528.858C370.637 528.886 366.46 525.631 366.46 525.631Z",
    fill: "#391B0B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M382.186 525.015C382.186 525.015 386.431 531.639 388.954 532.598C391.478 533.547 393.512 532.482 393.512 532.482C393.512 532.482 389.16 530.748 387.479 527.722C383.672 520.867 382.91 524.354 382.186 525.015Z",
    fill: "#81411E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.075 432.228C272.075 432.228 271.983 453.248 286.106 458.532C300.23 463.815 346.22 461.827 346.22 461.827C346.22 461.827 360.814 515.525 364.311 520.755C367.808 525.986 384.39 526.527 383.493 514.481C382.59 502.435 376.119 457.713 374.867 447.107C373.622 436.5 369.69 433.96 358.208 432.06C354.172 431.392 355.885 430.322 329.941 429.107C324.369 428.846 315.02 430.932 306.429 431.877C297.837 432.822 272.075 432.228 272.075 432.228Z",
    fill: "#7A3636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.977 432.681L317.977 430.24L319.127 430.068C323.309 429.447 327.111 428.975 329.94 429.107L332.923 429.252C355.756 430.407 354.333 431.419 358.207 432.06L358.953 432.186C369.616 434.033 373.474 436.614 374.78 446.419L375.146 449.37C376.874 462.962 382.644 503.158 383.493 514.481C383.56 515.387 383.529 516.222 383.411 516.99L380.05 500.062C375.096 474.966 372.32 460.096 371.722 455.452L371.597 454.487C370.478 446.244 367.55 436.016 358.101 436.683L357.285 436.752C350.632 437.258 338.016 435.982 319.436 432.923L317.977 432.681Z",
    fill: "white",
    fillOpacity: 0.192499
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_10",
    cx: 385.32,
    cy: 448.912,
    rx: 3.77561,
    ry: 6.61391,
    transform: "rotate(13 385.32 448.912)",
    fill: "white",
    fillOpacity: 0.192499
  })), /*#__PURE__*/React.createElement("g", {
    id: "RArm_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.263 404.315C282.263 404.315 297.654 407.878 297.498 409.276C297.345 410.682 290.569 410.898 290.569 410.898C290.569 410.898 303.095 418.987 302.098 420.565C301.101 422.143 292.934 423.921 289.545 422.648C286.154 421.375 277.367 412.112 277.367 412.112L282.263 404.315Z",
    fill: "url(#paint16_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.402 358.716C277.247 365.078 259.669 384.513 259.669 384.513C259.669 384.513 277.247 397.032 281.673 399.681C288.931 404.021 281.55 415.536 276.227 414.257C269.014 412.52 250.806 399.959 242.25 394.875C233.695 389.792 236.968 381.584 243.298 374.095C248.161 368.342 258.731 356.557 266.168 346.211C273.568 335.917 292.406 346.37 282.402 358.716Z",
    fill: "#EA5455"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.67 384.513C259.67 384.513 254.721 389.281 255.235 389.65C255.75 390.019 261.713 385.979 261.713 385.979L259.67 384.513Z",
    fill: "black",
    fillOpacity: 0.159856
  })), /*#__PURE__*/React.createElement("g", {
    id: "Head_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.093 312.007C317.416 312.48 317.109 320.089 311.847 320.486C310.771 327.821 306.936 331.315 302.259 331.719L302.518 342.813L281.833 342.801C281.833 342.801 287.658 334.964 287.368 324.235C287.077 313.506 287.562 303.427 287.562 303.427L314.355 303.908L313.093 312.007Z",
    fill: "url(#paint17_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.63 291.313C320.567 295.336 313.992 312.328 313.992 312.328C309.177 311.671 304.543 317.514 302.786 323.244C297.705 328.467 291.124 328.458 286.748 325.416C286.748 325.416 280.727 306.793 282.696 300.592C284.666 294.391 290.104 287.647 304.63 291.313Z",
    fill: "#2C272E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Body_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.957 345.288C265.526 347.724 264.501 357.536 266.957 396.408C268.229 416.537 262.819 436.376 264.217 445.109C265.615 453.843 275.223 454.886 275.223 454.886L280.826 436.657L283.462 454.886C283.462 454.886 323.196 451.171 326.678 442.125C330.167 433.06 325.785 411.75 324.743 391.683C323.697 371.537 324.482 350.858 322.556 347.724C318.713 341.468 308.821 338.546 302.682 337.61C294.891 336.423 284.833 336.377 278.854 338.273C272.875 340.168 268.388 342.852 266.957 345.288Z",
    fill: "#EA5455"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.385 359.131C310.521 382.265 314.714 398.498 319.964 407.83C322.135 411.688 324.34 413.279 326.58 412.602L326.048 407.475C325.518 402.287 325.015 396.942 324.742 391.683C324.551 388.016 324.422 384.331 324.325 380.737L307.385 359.131Z",
    fill: "black",
    fillOpacity: 0.159856
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.854 338.273C278.492 338.388 278.141 338.507 277.802 338.631C286.387 342.374 300.562 341.874 308.268 338.825C306.26 338.258 304.335 337.862 302.682 337.61C294.891 336.423 284.834 336.377 278.854 338.273Z",
    fill: "#E5AA41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LArm_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M384.153 379.168C384.153 379.168 396.938 370.633 399.197 368.919C401.449 367.212 404.276 354.268 402.524 352.452C401.678 351.574 395.282 357.486 394.141 358.278C393.007 359.062 387.208 362.556 387.208 362.556C387.208 362.556 388.849 352.649 387.436 351.85C386.391 351.268 384.3 353.818 384.021 356.513C383.741 359.208 380.834 362.723 380.459 366.813C380.289 368.6 378.53 372.013 378.53 372.013L384.153 379.168Z",
    fill: "url(#paint18_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.013 362.801C312.912 372.98 321.232 387.863 325.802 396.589C331.21 406.915 337.654 411.29 350.651 403.628C361.536 397.211 377.232 386.89 385.342 381.281C392.889 376.061 383.968 363.175 376.838 367.529C367.38 373.297 343.192 384.728 343.192 384.728C343.192 384.728 330.745 361.991 325.577 351.075C319.003 337.201 298.532 343.101 308.013 362.801Z",
    fill: "#EA5455"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M343.193 384.728C343.193 384.728 345.469 392.744 346.006 392.428C346.543 392.111 345.629 383.579 345.629 383.579L343.193 384.728Z",
    fill: "black",
    fillOpacity: 0.159856
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Chair8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292.769 463.221L281.326 544.179L287.326 544.1L298.769 464.067L292.769 463.221Z",
    fill: "#BFE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M330.93 463.221L342.373 544.179L336.374 544.1L324.931 464.067L330.93 463.221Z",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.884 463.221L246.441 544.179L252.441 544.1L263.884 464.067L257.884 463.221Z",
    fill: "#BFE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.307 467.983C340.523 467.983 344.752 463.754 344.752 458.538V458.538C344.752 453.321 340.523 449.093 335.307 449.093H297.544C291.823 449.093 287.041 444.739 286.505 439.043L280.467 374.85C279.931 369.153 275.149 364.8 269.428 364.8H245.728C239.269 364.8 234.178 370.298 234.672 376.738L240.897 457.744C241.341 463.522 246.158 467.983 251.952 467.983H335.307Z",
    fill: "#BFE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M344.75 458.457C344.698 458.458 344.646 458.458 344.594 458.458H292.611C286.818 458.458 282.001 453.998 281.556 448.222L275.248 366.363C278.192 368.121 280.266 371.21 280.609 374.847L286.642 438.806C287.18 444.501 291.961 448.853 297.681 448.853H335.331C340.534 448.853 344.752 453.071 344.752 458.274C344.752 458.335 344.751 458.396 344.75 458.457Z",
    fill: "#91D6FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Front Laptop3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_43",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M558.982 396.543C558.982 396.13 558.648 395.796 558.236 395.796H474.1C473.687 395.796 473.353 396.13 473.353 396.543V397.639C473.353 398.052 473.687 398.386 474.1 398.386H558.236C558.648 398.386 558.982 398.052 558.982 397.639V396.543Z",
    fill: "url(#paint19_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_44",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M558.99 396.543C558.99 396.13 558.656 395.796 558.244 395.796H525.917C525.505 395.796 525.17 396.13 525.17 396.543V397.639C525.17 398.052 525.505 398.386 525.917 398.386H558.244C558.656 398.386 558.99 398.052 558.99 397.639V396.543Z",
    fill: "#518DF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_45",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M565.094 360.353C565.369 358.201 563.693 356.296 561.523 356.296H505.712C503.9 356.296 502.371 357.642 502.141 359.439L497.99 391.852C497.714 394.004 499.391 395.909 501.561 395.909H557.372C559.183 395.909 560.713 394.563 560.943 392.766L565.094 360.353Z",
    fill: "#518DF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_46",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M563.394 360.353C563.67 358.201 561.993 356.296 559.824 356.296H505.192C503.381 356.296 501.851 357.642 501.621 359.439L497.47 391.852C497.195 394.004 498.871 395.909 501.041 395.909H555.673C557.484 395.909 559.013 394.563 559.244 392.766L563.394 360.353Z",
    fill: "url(#paint20_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_47",
    d: "M561.445 361.821C561.693 359.884 560.184 358.17 558.231 358.17H506.473C504.842 358.17 503.466 359.381 503.259 360.999L499.519 390.236C499.271 392.173 500.78 393.887 502.733 393.887H554.491C556.122 393.887 557.498 392.675 557.705 391.058L561.445 361.821Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Wom3.8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RArm_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M424.644 406.22C424.644 406.22 438.245 409.393 438.107 410.638C437.972 411.89 431.984 412.082 431.984 412.082C431.984 412.082 443.053 419.285 442.172 420.69C441.291 422.095 434.074 423.678 431.079 422.545C428.082 421.412 420.317 413.164 420.317 413.164L398.53 401.463L405.812 391.859L424.644 406.22Z",
    fill: "url(#paint21_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M424.768 365.617C420.212 371.282 404.679 388.587 404.679 388.587C404.679 388.587 407.745 390.888 407.745 390.888L397.773 402.985C397.773 402.985 391.405 399.083 389.286 397.815C381.725 393.288 384.618 385.98 390.212 379.311C394.509 374.189 403.85 363.695 410.422 354.482C416.962 345.316 433.609 354.623 424.768 365.617Z",
    fill: "#FFB66F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 15_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M404.679 388.587C404.679 388.587 400.305 392.833 400.76 393.162C401.215 393.491 406.484 389.893 406.484 389.893L404.679 388.587Z",
    fill: "black",
    fillOpacity: 0.159856
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 76",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M407.127 389.623L394.129 402.491L400.628 406.744L409.557 391.459L407.127 389.623Z",
    fill: "#FFEDC2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LLeg_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M448.635 505.233L441.604 527.882L453.422 528.413C453.422 528.413 451.756 520.665 454.134 513.403C456.041 507.572 457.598 504.663 457.598 504.663L448.635 505.233Z",
    fill: "url(#paint22_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M453.518 521.78C453.518 521.78 453.271 527.546 455.285 529.369C457.298 531.19 467.978 537.917 468.873 539.272C469.768 540.628 468.455 542.283 468.455 542.283C468.455 542.283 457.551 543.993 452.407 541.354C448.694 539.448 446.041 537.891 446.041 537.891L444.901 540.82L438.947 539.965C438.947 539.965 437.112 535.316 437.9 533.004C438.689 530.692 442.758 519.889 442.758 519.889C442.758 519.889 453.518 521.78 453.518 521.78Z",
    fill: "#391B0B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M414.247 428.031C423.136 428.898 466.92 439.326 475.935 441.178C484.95 443.03 492.572 453.051 485.698 464.654C477.976 477.679 456.149 518.158 456.149 518.158C456.014 518.191 455.882 518.249 455.746 518.249C451.306 518.249 447.348 517.641 443.537 514.985C443.537 514.985 449.328 472.54 462.811 460.712C462.811 460.712 427.993 473.231 410.581 459.571C400.309 451.513 404.451 427.075 414.247 428.031Z",
    fill: "#33373E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M482.573 444.255L480.182 474.278C480.379 473.928 480.574 473.582 480.766 473.24L483.044 444.637C482.89 444.506 482.733 444.379 482.573 444.255Z",
    fill: "white",
    fillOpacity: 0.192499
  })), /*#__PURE__*/React.createElement("g", {
    id: "RLeg_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M514.095 503.444C514.095 503.444 517.972 520.714 523.017 522.562C524.96 523.273 511.031 525.305 511.031 525.305L506.806 508.737L514.095 503.444Z",
    fill: "url(#paint23_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M509.257 520.544L512.935 542.165L519.311 541.157L518.524 535.811C518.524 535.811 521.32 540.468 524.439 540.267C527.567 540.065 543.209 537.707 543.209 537.707C543.209 537.707 543.561 532.529 536.366 531.346C530.381 530.363 520.176 518.809 520.176 518.809L509.257 520.544Z",
    fill: "#391B0B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M421.706 425.171C421.706 425.171 408.874 452.35 426.907 461.682C444.346 470.707 490.75 459.063 490.75 459.063C490.75 459.063 489.817 466.596 490.75 473.314C493.186 490.861 505.168 512.449 506.258 516.007C506.807 517.798 520.171 515.151 520.171 513.026C520.171 510.901 513.353 462.537 512.139 452.236C510.932 441.934 507.12 440.438 495.988 437.622C493.43 436.975 460.284 429.436 457.513 429.656C433.707 431.544 421.706 425.171 421.706 425.171Z",
    fill: "#42474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M457.513 429.656C460.284 429.436 493.43 436.975 495.988 437.622L497.815 438.091C507.311 440.575 510.83 442.428 512.053 451.547L512.382 454.165C513.384 461.804 516.092 479.769 518.235 494.725C515.817 489.228 513.816 483.129 512.232 476.427C508.54 460.808 509.33 447.982 508.339 445.736C507.347 443.49 458.859 436.32 450.528 434.84C446.901 434.196 444.856 432.599 444.391 430.048C448.417 430.161 452.791 430.031 457.513 429.656Z",
    fill: "white",
    fillOpacity: 0.192499
  })), /*#__PURE__*/React.createElement("g", {
    id: "Head_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.202 320.877C455.054 321.299 454.781 328.08 450.092 328.434C449.134 334.97 445.716 338.084 441.549 338.444L441.78 348.331L423.347 348.32C423.347 348.32 428.538 341.336 428.279 331.775C428.02 322.213 428.453 313.231 428.453 313.231L452.327 313.66L451.202 320.877Z",
    fill: "url(#paint24_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M452.042 321.385C447.555 319.609 444.241 327.257 440.808 332.573C437.375 337.888 428.482 336.985 427.256 332.573C422.615 322.908 418.616 309.769 424.031 308.691C424.794 294.723 461.308 298.021 452.042 321.385Z",
    fill: "#9E5229"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M427.018 303.156H434.931H435.042L435.117 303.239C442.146 311.095 443.72 322.664 440.435 333.099C440.181 333.427 439.905 333.727 439.609 334.001C443.288 323.471 441.879 311.618 434.818 303.656H426.43C426.617 303.483 426.813 303.316 427.018 303.156Z",
    fill: "black",
    fillOpacity: 0.199355
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_11",
    rx: 4.4008,
    ry: 4.40615,
    transform: "matrix(-1 0 0 1 431.867 303.406)",
    fill: "#FB9934"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Body_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M455.71 350.001C459.79 355.987 466.591 376.303 466.977 380.873C467.411 386.145 461.751 394.544 461.658 402.176C461.576 409.809 465.88 428.915 464.587 431.062C463.303 433.209 420.69 445.621 418.29 444.601C415.889 443.581 407.602 432.581 409.496 428.111C411.4 423.64 419.266 413.5 418.365 407.408C417.476 401.318 412.308 378.836 409.742 371.184C407.186 363.532 408.038 355.499 412.808 352.206C415.169 350.577 421.467 345.948 432.683 345.97C443.899 345.991 455.393 349.537 455.71 350.001Z",
    fill: "#FF9F43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.857 375.966L445.302 361.916L445.308 364.483C445.38 380.33 446.378 388.725 462.975 414.695L462.591 412.048C462.05 408.206 461.631 404.608 461.658 402.176C461.716 397.361 463.991 392.241 465.553 387.793L464.857 375.966Z",
    fill: "black",
    fillOpacity: 0.159856
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 68",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M443.045 345.532C443.045 345.532 443.517 348.106 441.451 348.106C439.384 348.106 425.524 348.562 423.647 347.748C421.771 346.934 422.334 345.532 422.334 345.532H443.045Z",
    fill: "#FFF6E1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LArm_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M512.124 380.861C512.124 380.861 523.41 373.328 525.405 371.815C527.393 370.309 529.888 358.885 528.342 357.283C527.595 356.507 521.948 361.725 520.941 362.424C519.941 363.116 514.82 366.2 514.82 366.2C514.82 366.2 516.269 357.456 515.022 356.751C514.099 356.238 512.254 358.488 512.007 360.866C511.76 363.245 509.194 366.347 508.862 369.956C508.713 371.533 508.129 373.577 508.129 373.577L476.813 387.025L480.09 401.648L512.124 380.861Z",
    fill: "url(#paint25_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.908 366.415C449.232 375.4 456.578 388.534 460.612 396.235C465.386 405.349 471.075 409.21 482.549 402.447C483.892 401.656 486.797 399.892 486.797 399.892L479.693 384.12C479.693 384.12 475.965 385.767 475.965 385.767C475.965 385.767 464.976 365.701 460.414 356.067C454.61 343.822 436.538 349.029 444.908 366.415Z",
    fill: "#FFB66F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M475.964 385.768C475.964 385.768 477.973 392.842 478.448 392.563C478.922 392.283 478.115 384.753 478.115 384.753L475.964 385.768Z",
    fill: "black",
    fillOpacity: 0.159856
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 75",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M479.591 383.423L484.539 403.058L491.9 399.077L482.24 381.894L479.591 383.423Z",
    fill: "#FFEDC2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M432.339 300.15C432.339 300.15 428.191 294.84 423.401 296.233C418.61 297.626 414.277 306.165 416.334 314.191C418.381 322.219 416.693 326.797 414.21 332.207C407.538 346.76 430.636 356 430.636 356C430.636 356 428.834 345.217 432.339 338.705C435.95 331.999 438 323.399 438 318.137C438 308.986 432.339 300.15 432.339 300.15Z",
    fill: "#9E5229"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Chair8_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M431.657 463.221L443.1 544.179L437.1 544.1L425.657 464.067L431.657 463.221Z",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.955 463.221L476.398 544.179L470.399 544.1L458.956 464.067L464.955 463.221Z",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M391.91 463.221L380.467 544.179L386.466 544.1L397.909 464.067L391.91 463.221Z",
    fill: "#BFE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M469.332 467.983C474.549 467.983 478.777 463.754 478.777 458.538V458.538C478.777 453.321 474.549 449.093 469.332 449.093H431.57C425.848 449.093 421.066 444.739 420.531 439.043L414.493 374.85C413.957 369.153 409.175 364.8 403.453 364.8H379.753C373.295 364.8 368.203 370.298 368.698 376.738L374.922 457.744C375.366 463.522 380.183 467.983 385.978 467.983H469.332Z",
    fill: "#BFE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M478.776 458.457C478.724 458.458 478.672 458.458 478.619 458.458H426.636C420.843 458.458 416.026 453.998 415.581 448.222L409.274 366.363C412.218 368.121 414.292 371.21 414.635 374.847L420.668 438.806C421.205 444.501 425.986 448.853 431.707 448.853H469.357C474.56 448.853 478.777 453.071 478.777 458.274C478.777 458.335 478.777 458.396 478.776 458.457Z",
    fill: "#91D6FF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 70.8555,
    y: 85.0081,
    width: 191.801,
    height: 107.428,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0862745 0 0 0 0 0.113725 0 0 0 0 0.192157 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 70.8555,
    y: 143.592,
    width: 224.949,
    height: 198.68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0862745 0 0 0 0 0.113725 0 0 0 0 0.192157 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 96.5059,
    y: 204.89,
    width: 161.424,
    height: 97.3127,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.144395 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d",
    x: 276.232,
    y: 107.237,
    width: 272.181,
    height: 197.485,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0862745 0 0 0 0 0.113725 0 0 0 0 0.192157 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 554.833,
    y1: 313.939,
    x2: 543.753,
    y2: 363.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F07777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 553.973,
    y1: 304.545,
    x2: 547.325,
    y2: 337.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 506.962,
    y1: 507.352,
    x2: 505.369,
    y2: 537.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 475.89,
    y1: 545.704,
    x2: 427.815,
    y2: 453.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28324F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222735"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 470.77,
    y1: 342.915,
    x2: 468.618,
    y2: 371.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 549.733,
    y1: 372.46,
    x2: 549.102,
    y2: 390.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 242.334,
    y1: 204.269,
    x2: 232.445,
    y2: 205.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D63A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222735"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 127.011,
    y1: 403.433,
    x2: 127.011,
    y2: 419.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE62BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB3A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 103.291,
    y1: 390.795,
    x2: 105.022,
    y2: 407.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE62BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB3A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 664.727,
    y1: 505.858,
    x2: 663.131,
    y2: 535.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 660.095,
    y1: 333.529,
    x2: 655.855,
    y2: 394.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 714.441,
    y1: 309.528,
    x2: 703.216,
    y2: 359.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F07777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 713.685,
    y1: 300.112,
    x2: 707.025,
    y2: 332.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 629.45,
    y1: 507.061,
    x2: 627.889,
    y2: 540.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 739.378,
    y1: 366.401,
    x2: 737.871,
    y2: 405.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 586.221,
    y1: 336.275,
    x2: 598.146,
    y2: 384.102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FF6EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D9DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 291.949,
    y1: 392.304,
    x2: 303.7,
    y2: 418.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A47070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 322.015,
    y1: 293.839,
    x2: 318.539,
    y2: 340.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A47070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 407.317,
    y1: 345.096,
    x2: 404.967,
    y2: 377.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A47070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 552.738,
    y1: 395.207,
    x2: 552.738,
    y2: 398.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FF6EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D9DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 559.031,
    y1: 347.282,
    x2: 559.031,
    y2: 395.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FF6EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D9DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 422.208,
    y1: 370.874,
    x2: 442.753,
    y2: 417.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCCA1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 460.365,
    y1: 498.881,
    x2: 457.668,
    y2: 527.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 526.04,
    y1: 498.123,
    x2: 523.808,
    y2: 524.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 459.153,
    y1: 304.686,
    x2: 456.055,
    y2: 346.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCCA1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 537.824,
    y1: 345.73,
    x2: 534.833,
    y2: 399.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCCA1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginDark);
export default __webpack_public_path__ + "static/media/login-dark.e7fe27f6ef411014a28cbcfdb7bcd149.svg";
export { ForwardRef as ReactComponent };